<div class="np-form-control dx-fieldset mainInfos" *ngIf="model">
    <!--SUPPLIER_NAME-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Lieferantenname' | translate }}</div>

        <div class="infoButton" *ngIf="!existingSupplierSelectedBool">
        <span
            id="supplierInfoIcon"
            class="dx-icon dx-icon-info info-icon">
      </span>
        </div>
        <div
            class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"

        >

            <label class="placeLabel {{ model.supplier.supplierName?.length > 0 ? 'placeLabelSmall' : '' }}">
                SUPPLIER_NAME
            </label>
            <div class="inline-elements"
                 style="display: flex; align-items: center;">
                <dx-select-box
                    [(value)]="model?.supplier.supplierName"
                    [showClearButton]="true"
                    [width]="'100%'"
                    [dataSource]="productDataSourceSuppliers"
                    valueExpr="id"
                    displayExpr="name"
                    placeholder=""
                    [acceptCustomValue]="true"
                    (onValueChanged)="catalogSupplierChanged($event)"
                    (onCustomItemCreating)="onCustomSupplierCreating($event)">
                </dx-select-box>
                <dx-button
                    icon="plus"
                    (onClick)="createNewDataSource()"
                >
                </dx-button>
                <dx-button *ngIf="existingSupplierSelectedBool"
                           icon="edit"
                           (onClick)="editDataSource()"
                >
                </dx-button>
            </div>
        </div>
    </div>
    <dx-tooltip
        target="#supplierInfoIcon"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [closeOnOutsideClick]="false">
        <div>
            Kein passender Eintrag in den Datenquellen vorhanden.
        </div>

    </dx-tooltip>

    <!--SUPPLIER_ID-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Lieferantenkennung' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label
                class="placeLabel {{ model.supplier.supplierId?.length > 0 ? 'placeLabelSmall' : '' }}">SUPPLIER_ID</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierId')"
                         [(value)]="model?.supplier.supplierId"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--SUPPLIER_ID_TYPE-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'ID-Typ' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label class="placeLabel {{ model.supplier.supplierIdType?.length > 0 ? 'placeLabelSmall' : '' }}">
                SUPPLIER_ID_TYPE
            </label>
            <dx-autocomplete [minSearchLength]="0"
                             [dataSource]="idType"
                             [showClearButton]="true"
                             [showDropDownButton]="true"
                             [(value)]="model?.supplier.supplierIdType"
                             valueChangeEvent="focusout"
                             (onValueChanged)="catalogChanged($event)"
                             [readOnly]="readOnlyUser('supplierType')"></dx-autocomplete>
        </div>
    </div>

    <!--CONTACT-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Ansprechpartner' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label class="placeLabel {{ model.supplier.address.contact?.length > 0 ? 'placeLabelSmall' : '' }}">
                CONTACT
            </label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddresssContact')"
                         [(value)]="model.supplier.address.contact"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--STREET-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Straße' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label
                class="placeLabel {{ model.supplier.address.street?.length > 0 ? 'placeLabelSmall' : '' }}">STREET</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressStreet')"
                         [(value)]="model.supplier.address.street"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--ZIP-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'PLZ' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label class="placeLabel {{ model.supplier.address.zip?.length > 0 ? 'placeLabelSmall' : '' }}">ZIP</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressZip')"
                         [(value)]="model.supplier.address.zip"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--CITY-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Ort' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label
                class="placeLabel {{ model.supplier.address.city?.length > 0 ? 'placeLabelSmall' : '' }}">CITY</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressCity')"
                         [(value)]="model.supplier.address.city"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--STATE-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Bundesland' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label
                class="placeLabel {{ model.supplier.address.state?.length > 0 ? 'placeLabelSmall' : '' }}">STATE</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressState')"
                         [(value)]="model.supplier.address.state"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--COUNTRY-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Land' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label class="placeLabel {{ model.supplier.address.country?.length > 0 ? 'placeLabelSmall' : '' }}">
                COUNTRY
            </label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressCountry')"
                         [(value)]="model.supplier.address.country"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--PHONE-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Telefon' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label
                class="placeLabel {{ model.supplier.address.phone?.length > 0 ? 'placeLabelSmall' : '' }}">PHONE</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressPhone')"
                         [(value)]="model.supplier.address.phone"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--FAX-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Telefax' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label class="placeLabel {{ model.supplier.address.fax?.length > 0 ? 'placeLabelSmall' : '' }}">FAX</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressFax')"
                         [(value)]="model.supplier.address.fax"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--EMAIL-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'E-Mail' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label
                class="placeLabel {{ model.supplier.address.email?.length > 0 ? 'placeLabelSmall' : '' }}">EMAIL</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressEmail')"
                         [(value)]="model.supplier.address.email"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--URL-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Homepage' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label class="placeLabel {{ model.supplier.address.url?.length > 0 ? 'placeLabelSmall' : '' }}">URL</label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressUrl')"
                         [(value)]="model.supplier.address.url"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>

    <!--ADDRESS_REMARKS-->
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Bemerkung' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label class="placeLabel {{ model.supplier.address.addressRemarks?.length > 0 ? 'placeLabelSmall' : '' }}">
                ADDRESS_REMARKS
            </label>
            <dx-text-box [readOnly]="readOnlyUser('supplierAddressRemarks')"
                         [(value)]="model.supplier.address.addressRemarks"
                         [showClearButton]="true"
                         valueChangeEvent="focusout"
                         (onValueChanged)="catalogChanged($event)"></dx-text-box>
        </div>
    </div>
</div>

<app-edit-datasource [(visible)]="popupVisible"
                     [editMode]="isEdit"
                     [dataSource]="newOrUpdateProductDataSource"
                     [relatedBrands]="relatedBrands"
                     [types]="types"
                     [countryCodes]="countryCodes"
                     (saved)="onEditSaved($event)">
</app-edit-datasource>
